<prlw-mobile-menu-ui
  [items]="items"
  (eventMobileSubmenuItemClick)="handleMobileSubmenuItemClick($event)"
  (eventClose)="eventClose.emit()"
></prlw-mobile-menu-ui>
